import { Form, Field } from 'formik';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import * as Yup from 'yup';
import { numericValue } from '@utils';

const form =
  ({ role, allCompany, isEditing, loading }) =>
  ({ errors, touched, setFieldValue }) =>
    (
      <Form>
        <div className='m-0 form'>
          {role === 'admin' && !isEditing && (
            <div className='form__elem'>
              <span className='p-float-label'>
                <Field name='company' className={errors.company && touched.company ? 'p-invalid' : ''}>
                  {({ field }) => (
                    <Dropdown
                      value={field.value}
                      options={allCompany ?? []}
                      onChange={(e) => setFieldValue('company', e.value)}
                      optionLabel='name'
                    />
                  )}
                </Field>
                <label htmlFor='company'>Підриємство</label>
              </span>
              {errors.company && touched.company ? (
                <small id='company-help' className='p-error'>
                  {errors.company}
                </small>
              ) : null}
            </div>
          )}
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field name='name' as={InputText} className={errors.name && touched.name ? 'p-invalid' : ''} />
              <label htmlFor='name'>Найменування</label>
            </span>
            {errors.name && touched.name ? (
              <small id='name-help' className='p-error'>
                {errors.name}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='certificate'
                as={InputText}
                className={errors.certificate && touched.certificate ? 'p-invalid' : ''}
              />
              <label htmlFor='certificate'>Сертрифікат</label>
            </span>
            {errors.certificate && touched.certificate ? (
              <small id='certificate-help' className='p-error'>
                {errors.certificate}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field name='unit' as={InputText} className={errors.unit && touched.unit ? 'p-invalid' : ''} />
              <label htmlFor='unit'>Одиниця виміру</label>
            </span>
            {errors.unit && touched.unit ? (
              <small id='unit-help' className='p-error'>
                {errors.unit}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='length'
                as={InputText}
                onChange={(e) => setFieldValue('length', numericValue(e.target.value))}
                useGrouping={false}
                className={errors.length && touched.length ? 'p-invalid' : ''}
              />
              <label htmlFor='length'>Довжина</label>
            </span>
            {errors.length && touched.length ? (
              <small id='length-help' className='p-error'>
                {errors.length}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='height'
                as={InputText}
                onChange={(e) => setFieldValue('height', numericValue(e.target.value))}
                useGrouping={false}
                className={errors.height && touched.height ? 'p-invalid' : ''}
              />
              <label htmlFor='height'>Висота</label>
            </span>
            {errors.height && touched.height ? (
              <small id='height-help' className='p-error'>
                {errors.height}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='width'
                as={InputText}
                onChange={(e) => setFieldValue('width',  numericValue(e.target.value))}
                useGrouping={false}
                className={errors.width && touched.width ? 'p-invalid' : ''}
              />
              <label htmlFor='width'>Ширина</label>
            </span>
            {errors.width && touched.width ? (
              <small id='width-help' className='p-error'>
                {errors.width}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='volume'
                as={InputText}
                onChange={(e) => setFieldValue('volume', numericValue(e.target.value))}
                useGrouping={false}
                className={errors.volume && touched.volume ? 'p-invalid' : ''}
              />
              <label htmlFor='volume'>Об`єм</label>
            </span>
            {errors.volume && touched.volume ? (
              <small id='volume-help' className='p-error'>
                {errors.volume}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='mass'
                as={InputText}
                onChange={(e) => setFieldValue('mass', numericValue(e.target.value))}
                useGrouping={false}
                className={errors.mass && touched.mass ? 'p-invalid' : ''}
              />
              <label htmlFor='mass'>Маса</label>
            </span>
            {errors.mass && touched.mass ? (
              <small id='mass-help' className='p-error'>
                {errors.mass}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='codeUKTZED'
                as={InputText}
                className={errors.codeUKTZED && touched.codeUKTZED ? 'p-invalid' : ''}
              />
              <label htmlFor='codeUKTZED'>Код УКТ ЗЕД</label>
            </span>
            {errors.codeUKTZED && touched.codeUKTZED ? (
              <small id='codeUKTZED-help' className='p-error'>
                {errors.codeUKTZED}
              </small>
            ) : null}
          </div>
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field
                name='price'
                as={InputText}
                onChange={(e) => setFieldValue('price', numericValue(e.target.value))}
                useGrouping={false}
                className={errors.price && touched.price ? 'p-invalid' : ''}
              />
              <label htmlFor='price'>Ціна за одиницю з ПДВ</label>
            </span>
            {errors.price && touched.mass ? (
              <small id='price-help' className='p-error'>
                {errors.price}
              </small>
            ) : null}
          </div>

          <Button
            type='submit'
            loading={loading}
            className='form__button'
            label={isEditing ? 'Зберегти' : 'Створити'}
            icon='pi pi-check'
          />
        </div>
      </Form>
    );
const schema = ({ role, isEditing }) => {
  return Yup.object().shape({
    ...(role === 'admin' && !isEditing
      ? {
          company: Yup.object().required('Виберіть підприємство'),
        }
      : {}),
    name: Yup.string().required('Напишіть назву').min(2, 'Занадто коротке!').max(100, 'Занадто довге!'),
    certificate: Yup.string().min(2, 'Занадто коротке!').max(120, 'Занадто довге!'),
    unit: Yup.string().min(2, 'Занадто коротке!').max(120, 'Занадто довге!'),
    length: Yup.string().min(1, 'Занадто коротке!').max(100, 'Занадто довге!'),
    height: Yup.string().min(1, 'Занадто коротке!').max(100, 'Занадто довге!'),
    width: Yup.string().min(0, 'Занадто коротке!').max(100, 'Занадто довге!'),
    volume: Yup.string().min(0, 'Занадто коротке!').max(100, 'Занадто довге!'),
    mass: Yup.string().min(0, 'Занадто коротке!').max(100, 'Занадто довге!'),
    codeUKTZED: Yup.string().min(2, 'Занадто короткий!').max(100, 'Занадто довгий!'),
    price: Yup.string().min(0, 'Занадто коротке!').max(100, 'Занадто довге!'),
  });
};

const initialValues = (data, role, isEditing) => {
  return {
    ...(role === 'admin' && !isEditing
      ? {
          company: data?.company_id ? { _id: data?.company_id, name: data?.company_name } : null,
        }
      : {}),
    name: data?.name ?? '',
    certificate: data?.certificate ?? '',
    unit: data?.unit ?? '',
    length: data?.length ?? '',
    height: data?.height ?? '',
    width: data?.width ?? '',
    volume: data?.volume ?? '',
    mass: data?.mass ?? '',
    codeUKTZED: data?.codeUKTZED ?? '',
    price: data?.price ?? '',
  };
};

export default { form, schema, initialValues };
